import { useState, useContext, useEffect, useMemo } from "react";
import { Link, useLocation, useParams } from "react-router-dom";

import AppContext from "../../store/app-context";

import './Header.scss';
import { FaBars, FaChevronRight } from 'react-icons/fa';

const Header = () => {
    const appCtx = useContext(AppContext);
    const [screenTitle, setScreenTitle] = useState({
        title: '',
        parent: {
            path: '',
            name: ''
        }
    });

    const breadcrumbsConfig:any = useMemo(() => {
        return  {
            '/': { title: 'Home', parent: null},
            '/courier': { title: 'Courier Route', parent: { path: '/', name: 'Home'}},
            '/courier/order': { title: 'Order', parent: { path: '/courier', name: 'Courier Route'}},
            '/courier/warehouse': { title: 'Warehouse', parent: { path: '/courier', name: 'Courier Route'}},
            '/incoming': { title: 'Incoming', parent: { path: '/', name: 'Home'}},
            '/dispatch': { title: 'Dispatch', parent: { path: '/', name: 'Home'}},
            '/settings': { title: 'Settings', parent: { path: '/', name: 'Home'}},
            '/tools': { title: 'Tools', parent: { path: '/', name: 'Home'}},
            '/configuration/vehicles': { title: 'Vehicles', parent: { path: '/', name: 'Home'}},
            '/configuration/service-areas': { title: 'Service Areas', parent: { path: '/', name: 'Home'}},
            '/configuration/pricing': { title: 'Pricing', parent: { path: '/', name: 'Home'}}
        };
    }, []);

    const { pathname, search } = useLocation();
    const params = useParams();

   useEffect(() => {
        // Strip all route param values from pathname to match breadcrumb config keys.
        // e.g. /courier/order/123/collection → /courier/order
        let path = pathname;
        const paramValues = Object.values(params).filter(Boolean);
        for (const val of paramValues) {
            path = path.replace('/' + val, '');
        }

        let breadcrumbs = breadcrumbsConfig[path];
        if(!breadcrumbs) breadcrumbs = { title: 'No breadcrumbs configured', parent: null };

        setScreenTitle(breadcrumbs);
    }, [search, params, pathname, breadcrumbsConfig]);

    return (
        <header className="app-header">
            <div className="inner">
                <button className="menu-toggle" onClick={() => appCtx.toggleMenu()} aria-label="Open menu">
                    <FaBars />
                </button>
                <nav className="breadcrumbs">
                    {screenTitle.parent && <>
                        <Link to={screenTitle.parent.path}>{ screenTitle.parent.name }</Link>
                        <FaChevronRight className="separator" />
                    </>}
                    <span className="current">{ screenTitle.title }</span>
                </nav>
                <img src="/kit-keeper-logo.svg" alt="Kit Keeper logo" />
            </div>
        </header>
    );
}

export default Header;
